 export enum TypeRegroupementEquipe {
responsable = 1,
service = 2,
alphabetique = 3,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TypeRegroupementEquipe.ts